import React from 'react';
import {Route, Routes, NavLink} from 'react-router-dom';
import ReportsSmsSummary from './summary';
const cx = require('classnames');

class RoutingWrapper extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            routes: [
                {type: 'route', url: 'summary', name: 'Summary'},
                {type: 'route', url: 'smslog', name: 'SMS Log'},
                {type: 'route', url: 'surcharges', name: 'SMS Surcharges'}
            ]
        }
    }
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h2>SMS Reports</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <ul className="nav nav-tabs">
                            {this.state.routes.map(function(row, i) {
                                var location = '/reports/sms/' + row.url;
                                return (
                                    <li key={i} role="presentation" className={cx(location == this.props.pathname ? "active" : "")}>
                                        <NavLink exact={true} to={ location }>{row.name}</NavLink>
                                    </li>)
                            }, this)}
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}

export default class extends React.Component {
    render() {
        return (
            <div>
                <RoutingWrapper urlattrs={this.props.urlattrs} pathname={this.props.location?.pathname}/>
                <Routes>
                    <Route index element={<ReportsSmsSummary childProps={this.props.childProps}/>} />
                    {this.props.routes.map((route, i) => (
                        <Route key={i} path={route.path} 
                            element={<route.component routes={route.routes} childProps={this.props.childProps}/>} 
                        />
                    ))}
                </Routes>
            </div>
        )
    }
}
